export enum DataPackageValidationModeEnum {
    Any = 'Any',
    All = 'All',
}
